// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2H1EP","content":"styles_content__1aiSl","checkbox":"styles_checkbox__1AZte","checkboxLabel":"styles_checkboxLabel__2MxTi"};